import PropTypes from 'prop-types';
import React from 'react';

import Header from '../../components/Header';
import './Private.style.scss';

const Private = ({children}) => {
  return (
    <div className="main-content-private">
      <Header />
      {children}
    </div>
  );
};

Private.propTypes = {children: PropTypes.element};

export default Private;
